var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCsMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 14V9.2C2 7.29044 2.84285 5.45909 4.34315 4.10883C5.84344 2.75857 7.87827 2 10 2C12.1217 2 14.1566 2.75857 15.6569 4.10883C17.1571 5.45909 18 7.29044 18 9.2V14",
    stroke: "#16191D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16.1667C18 16.6087 17.8244 17.0326 17.5118 17.3452C17.1993 17.6577 16.7754 17.8333 16.3333 17.8333H15.5C15.058 17.8333 14.634 17.6577 14.3215 17.3452C14.0089 17.0326 13.8333 16.6087 13.8333 16.1667V13.6667C13.8333 13.2246 14.0089 12.8007 14.3215 12.4882C14.634 12.1756 15.058 12 15.5 12H18V16.1667ZM2 16.1667C2 16.6087 2.17559 17.0326 2.48816 17.3452C2.80072 17.6577 3.22464 17.8333 3.66667 17.8333H4.5C4.94203 17.8333 5.36595 17.6577 5.67851 17.3452C5.99107 17.0326 6.16667 16.6087 6.16667 16.1667V13.6667C6.16667 13.2246 5.99107 12.8007 5.67851 12.4882C5.36595 12.1756 4.94203 12 4.5 12H2V16.1667Z",
    stroke: "#16191D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCsMenu);
export default __webpack_public_path__ + "static/media/icon-cs-menu.300b37ce2deee05556378abf113c5523.svg";
export { ForwardRef as ReactComponent };